import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteLanguage,
  getLanguageById,
  postLanguage,
  updateLanguage,
} from "../../../../api/language";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyLanguage() {
  return {
    fullName: "",
    isocode: "",
  };
}

export default function EditLanguagesPage() {
  const [language, setLanguage] = useState(getEmptyLanguage());
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const languageId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!languageId) {
      disableLoadingData();
      return;
    }
    getLanguageById(languageId)
      .then((res) => {
        if (res.status === 200) {
          setLanguage(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get language." });
        history.push("/languages");
      });
  }, [languageId, disableLoadingData, history]);

  function saveLanguage() {
    if (!languageId) {
      postLanguage(language)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Language successfully created.",
            });
            history.push("/languages");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save language.",
          });
        });
    } else {
      updateLanguage(languageId, language)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            history.push("/languages");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setLanguage({ ...language, [element]: event.target.value });
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/languages"),
            onSave: saveLanguage,
            showDelete: !!false,
            setObj: setLanguage,
            obj: language,
          })}
          <CardHeader title="Edit language"></CardHeader>
          <CardBody>
            <TextField
              id={`fullName`}
              label="Full name"
              value={language.fullName}
              onChange={handleChange("fullName")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              id={`isocode`}
              label="ISO code"
              value={language.isocode}
              onChange={handleChange("isocode")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
              disabled={languageId}
            />
          </CardBody>
        </Card>

        {languageId && language.isocode !== "es" && (
          <>
            <ConfirmDialog
              title={"Are you sure you want to delete this language?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteLanguage(languageId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Language deleted successfully",
                      });
                      history.push("/languages");
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not delete economic sector.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
